module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("A"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("The story “People of the Summit” is a rewritten version of a story by the same title, by Björn Nyberg, in "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Mighty Swordsmen")]), _vm._v(" (N.Y.: Lancer Books, 1970), copyright © 1970 by Hans Stefan Santesson.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The article “Hyborian Names” is expanded from the following articles by L. Sprague de Camp: “An Exegesis of Howard’s Hyborian Tales” in "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Amra,")]), _vm._v(" II, 4, 5, and 6, copyright © 1959 by L. Sprague de Camp; “Addenda to the Exegesis” in "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Amra")]), _vm._v(" II, 6, copyright © 1959 by George H. Scithers; “Exegetical Addenda” in "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Amra,")]), _vm._v(" II, 9, copyright © 1960 by George H. Scithers; “Addenda to the Exegesis” in "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Amra,")]), _vm._v(" II, 40, copyright © 1966 by the Terminus, Owlswick, and Ft. Mudge Electrick Street Railway Gazette; “Superaddendum to the Exegesis” in "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Amra,")]), _vm._v(" II, 45, copyright © 1967 by L. Sprague de Camp; “An Exegesis of Howard’s Hyborian Tales” in "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Conan Reader")]), _vm._v(" (Baltimore: Mirage Press, 1968), copyright © 1968 by L. Sprague de Camp; and “An Exegesis of Names Discarded by REH” in "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Amra,")]), _vm._v(" II, 51, copyright © 1969 by L. Sprague de Camp.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("All the other materials in this volume are published here for the first time.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a27ef4d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 69
// module chunks = 0